// Shine on Coin brand logo — inline SVG (no external asset)
// A gold-rimmed coin with an inner sparkle representing "shine".
// Renders on top of a gold-gradient circle disc so it works on any background.
export default function BrandLogo({ size = 36, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[#f3e5ab] via-[#d4af37] to-[#7a5d10] text-black shadow-[0_2px_20px_rgba(212,175,55,0.35)] ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 48 48"
        width={Math.round(size * 0.72)}
        height={Math.round(size * 0.72)}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer coin rim */}
        <circle cx="24" cy="24" r="21" stroke="#3a2a05" strokeWidth="2.2" />
        {/* Inner coin field (subtle darker gold to give depth on the disc) */}
        <circle cx="24" cy="24" r="16.5" stroke="#3a2a05" strokeWidth="1.1" strokeDasharray="1 1.6" />
        {/* Four-point sparkle — the "shine" mark */}
        <path
          d="M24 8.5 L26.2 21.8 L39.5 24 L26.2 26.2 L24 39.5 L21.8 26.2 L8.5 24 L21.8 21.8 Z"
          fill="#1a1200"
        />
        {/* Tiny secondary sparkle for a little extra life */}
        <path
          d="M35 12 L35.9 14.4 L38.3 15.3 L35.9 16.2 L35 18.6 L34.1 16.2 L31.7 15.3 L34.1 14.4 Z"
          fill="#1a1200"
          opacity="0.75"
        />
      </svg>
    </span>
  );
}
